import React, { Fragment, useEffect, useState } from 'react'
import { useStyles } from './style'
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Typography,
  Tooltip,
  IconButton,
  Fade,
  Button
} from '@mui/material'
import { SpeedMeterChart } from '../../components/Charts/SpeedMeter/SpeedMeterChart'
import { apiCall, ApiConfig } from '../../config/api'
import { useWarehouses } from '../../hooks/useWarehouses'
import { useZones } from '../../hooks/useZones'
import { Selector } from '../../components/Selector/Selector'
import RefreshIcon from '@mui/icons-material/Refresh'
import { FillRateDataReport } from '../../interfaces/DashBoard/FillRate'
import { graphLoader } from '../../images/graphLoader'
import { FillRateElementList } from '../../components/FillRate'
import { dataGridSettings } from '../../components/FillRate/fillRateConfig'
import {
  DataGridSettings,
  SortField
} from '../../interfaces/DataGrid/DataGridSettings'

interface FillRatePageProps {}

export const FillRatePage: React.FC<FillRatePageProps> = () => {
  const [wareHouse, setWareHouse] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [fillRateData, setFillRateData] = useState<FillRateDataReport>()
  const [rowsPerPage, setRowsPerPage] = useState<number>(5)
  const [page, setPage] = useState<number>(1)
  const [sorters, setSorters] = useState<SortField[]>(
    DataGridSettings.defaultSorters(dataGridSettings)
  )

  const classes = useStyles()

  const {
    warehousesState: { warehouses },
    getWarehouses
  } = useWarehouses()

  useEffect(() => {
    if (warehouses?.length === 0) {
      getWarehouses()
    }
  }, [])

  const {
    zonesState: { zones },
    getZones
  } = useZones()

  useEffect(() => {
    if (zones?.length === 0) {
      getZones()
    }
  }, [])

  const handleGetDataDashBoard = () => {
    setLoading(true)
    let warehouseId: string = ''
    let initialDate: string = ''

    initialDate = `InitialDate=${new Date().toISOString().slice(0, 10)} `

    if (wareHouse > 0) {
      warehouseId = `&WarehouseId=${wareHouse}`
    }

    apiCall(
      'GET',
      `${ApiConfig.WorkOrderApi}/GetFillrateOT?${initialDate}${warehouseId}`
    )
      .then((response) => {
        if (response.status === 200 && response.data !== null) {
          setFillRateData(response.data)

          setLoading(false)
        }
      })
      .catch((message) => {
        console.log('message: ', message)
      })
  }

  useEffect(() => {
    handleGetDataDashBoard()
  }, [wareHouse])

  const handlePageChange = (updatePage: number) => {
    setPage(updatePage - 1)
  }

  const handlePageSizeChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setPage(0)
    setRowsPerPage(event.target.value as number)
  }

  const handleOnSortChanged = (sorters: SortField[]) => {
    setSorters(sorters)
  }

  return loading ? (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={12}>
          <Paper className={classes.paper}>
            <img
              src={graphLoader}
              alt='graph'
              style={{
                width: '211px',
                height: '200px',
                maxWidth: '211px',
                minWidth: '200px',
                opacity: '1',
                borderRadius: '100px'
              }}
            />
            <Typography
              variant='h4'
              color='textSecondary'
              component='h4'
              className={classes.textColor}
            >
              {'Generando Reporte...'}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Fragment>
  ) : (
    <Fragment>
      <Paper className={classes.paper} elevation={2}>
        <Fade in={true}>
          <Fragment>
            <Grid container spacing={1}>
              <Grid container item sm={12} spacing={6} lg={10}>
                <Grid item sm={12} lg={2}>
                  <Typography variant='h5' component='h2'>
                    {'Por OT'}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                lg={2}
                style={{ marginLeft: '40px' }}
              >
                <Grid item sm={12} lg={9}>
                  <Typography
                    variant='body2'
                    color='textSecondary'
                    component='p'
                    className={classes.textColor}
                  >
                    {`Actualizado ${new Date().getHours()}:${
                      new Date().getMinutes() > 9
                        ? new Date().getMinutes()
                        : `0${new Date().getMinutes()}`
                    }`}
                  </Typography>
                </Grid>
                <Grid item sm={12} lg={1}>
                  <Tooltip title='Refrescar' placement='top-end'>
                    <IconButton
                      className={``}
                      onClick={handleGetDataDashBoard}
                      style={{ padding: '0' }}
                    >
                      <RefreshIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid container item xs={12} lg={3}>
                <Grid item sm={12} lg={6}>
                  <Box pt={3}>
                    <InputLabel id='selectedFillRate'>Fillrate por</InputLabel>
                  </Box>
                </Grid>
                <Grid item sm={12} lg={1}>
                  <Box>
                    <FormControl>
                      <Selector
                        labelId='selectedFillRateWareHouse'
                        item={warehouses!.map((item) => ({
                          value: item.id,
                          name: item.warehouseName
                        }))}
                        defaultLabel='Almacén'
                        onChange={(e) => setWareHouse(e.target.value as number)}
                        id='warehouseId'
                        name='warehouseId'
                        value={wareHouse}
                      />
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
              <Grid container item xs={12} lg={8}>
                <Grid item sm={12} lg={9} style={{ marginBottom: '-33px' }}>
                  <SpeedMeterChart
                    data={fillRateData?.totalOT.fillrate!}
                    height={'480'}
                    startAngle={-90}
                    endAngle={90}
                    fontSizeLabel={'20px'}
                    fontSizeValue={'40px'}
                    heightChart={'270'}
                    alignZeroPercent={'-40px 0 0 -265px'}
                    alignHundredPercent={'-20px 0 0 280px'}
                    comply={
                      fillRateData !== undefined
                        ? fillRateData.totalOT.completedQty
                        : 0
                    }
                    noComply={
                      fillRateData !== undefined
                        ? fillRateData.totalOT.realQty -
                          fillRateData.totalOT.completedQty
                        : 0
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Fragment>
        </Fade>
      </Paper>

      <Paper className={classes.paper} elevation={2}>
        <Fade in={true}>
          <Grid container spacing={1}>
            <Grid container item sm={12} spacing={6} lg={10}>
              <Grid item sm={12} lg={3}>
                <Typography variant='h5' component='h2'>
                  {'Por Producto'}
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              item
              xs={12}
              lg={2}
              style={{ marginLeft: '40px', visibility: 'hidden' }}
            >
              <Grid item sm={12} lg={9}>
                <Typography
                  variant='body2'
                  color='textSecondary'
                  component='p'
                  className={classes.textColor}
                >
                  {`Actualizado ${new Date().getHours()}:${
                    new Date().getMinutes() > 9
                      ? new Date().getMinutes()
                      : `0${new Date().getMinutes()}`
                  }`}
                </Typography>
              </Grid>
              <Grid item sm={12} lg={1}>
                <Tooltip title='Refrescar' placement='top-end'>
                  <IconButton
                    className={``}
                    onClick={handleGetDataDashBoard}
                    style={{ padding: '0' }}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>

            <Grid container item xs={12} lg={5}>
              <Grid item sm={12} lg={12}>
                <SpeedMeterChart
                  data={fillRateData?.totalUnits.fillrate!}
                  height={'480'}
                  startAngle={-90}
                  endAngle={90}
                  fontSizeLabel={'20px'}
                  fontSizeValue={'40px'}
                  heightChart={'270'}
                  alignZeroPercent={'-40px 0 0 -265px'}
                  alignHundredPercent={'-20px 0 0 280px'}
                  comply={
                    fillRateData !== undefined
                      ? fillRateData.totalUnits.completedQty
                      : 0
                  }
                  noComply={
                    fillRateData !== undefined
                      ? fillRateData.totalUnits.realQty -
                        fillRateData.totalUnits.completedQty
                      : 0
                  }
                />
              </Grid>
            </Grid>

            <Grid container xs={12} lg={5}>
              <Grid container xs={12} lg={12}>
                <Grid item key={`HDR-OT`} xs={12} sm={6} lg={3}>
                  <Button variant='outlined' color='inherit' fullWidth={true}>
                    {`OT`}
                  </Button>
                </Grid>
                <Grid item key={`HDR-Fillrate`} xs={12} sm={6} lg={3}>
                  <Button variant='outlined' color='inherit' fullWidth={true}>
                    {`Fillrate`}
                  </Button>
                </Grid>
                <Grid item key={`HDR-UTotales`} xs={12} sm={6} lg={3}>
                  <Button variant='outlined' color='inherit' fullWidth={true}>
                    {`U. Totales`}
                  </Button>
                </Grid>
                <Grid item key={`HDR-Detalle`} xs={12} sm={6} lg={3}>
                  <Button variant='outlined' color='inherit' fullWidth={true}>
                    {`Detalle`}
                  </Button>
                </Grid>
              </Grid>
              <Grid
                item
                sm={12}
                lg={12}
                className={`${classes.scrollBarB} ${classes.root2}`}
              >
                <FillRateElementList
                  plannerList={
                    fillRateData !== undefined ? fillRateData.items : []
                  }
                  page={page + 1}
                  totalPages={Math.ceil(1 / rowsPerPage)}
                  handlePagination={handlePageChange}
                  pageSize={rowsPerPage}
                  handlePageSize={handlePageSizeChange}
                  sorters={sorters}
                  handleOnSortChanged={handleOnSortChanged}
                />
              </Grid>
            </Grid>
          </Grid>
        </Fade>
      </Paper>
    </Fragment>
  )
}
